import { render } from "./carruselcomponent2.vue?vue&type=template&id=648aa20c&scoped=true"
import script from "./carruselcomponent2.vue?vue&type=script&lang=js"
export * from "./carruselcomponent2.vue?vue&type=script&lang=js"

import "./carruselcomponent2.vue?vue&type=style&index=0&id=648aa20c&scoped=true&lang=css"
import "./carruselcomponent2.vue?vue&type=style&index=1&id=648aa20c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-648aa20c"]])

export default __exports__